import React, { useState } from "react";
import AutoSuggest from "react-autosuggest";
import "./AutoComplete.css";

const AutoComplete = ({
  data,
  onChange,
  onSelection,
  value,
  placeholder,
  maxLength,
  onBlur,
  theme
}) => {
  const [state, setState] = useState({
    value: "",
    suggestions: []
  });

  const onSuggestionsFetchRequested = ({ value }) => {
    setState({
      suggestions: getSuggestions(value)
    });
  };

  const onSuggestionsClearRequested = () => {
    setState({
      suggestions: []
    });
  };

  const getSuggestions = (searchValue) =>
    data.filter((item) =>
      item.name
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .includes(
          searchValue
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
        )
    );

  return (
    <AutoSuggest
      suggestions={state.suggestions}
      onSuggestionsFetchRequested={onSuggestionsFetchRequested}
      onSuggestionsClearRequested={onSuggestionsClearRequested}
      onSuggestionSelected={(event, { suggestion, suggestionValue }) => {
        onSelection(suggestion.id);
      }}
      getSuggestionValue={(suggestion) => suggestion.name}
      renderSuggestion={(suggestion) => (
        <span key={suggestion.id}>{suggestion.name}</span>
      )}
      inputProps={{
        onChange: onChange,
        value: value || "",
        placeholder: placeholder,
        maxLength: maxLength,
        onBlur: onBlur
      }}
      highlightFirstSuggestion={true}
      theme={theme}
    />
  );
};

export default AutoComplete;
